import AuthTopBar from "../component/AuthTopBar";
import { Link, useNavigate } from "react-router-dom";
import GoogleSignIn from "../component/GoogleSignIn";
import AuthForm from "../component/AuthForm";
import { useEffect, useState } from "react";
import { useUserInfo } from "../../../context/user";
import localforage from "localforage";
import LocationModal from "../component/LocationModal";
import ForgetModel from "../component/ForgetModel";
import { useLogin, useCreateCustomer } from "../../../queries/auth";

const SignInPage = () => {
  const navigate = useNavigate();
  const loginMutation = useLogin();
  const createCustomerMutation = useCreateCustomer();
  const [error, setError] = useState("");
  const agencyData = useUserInfo()[11];
  const updateUser = useUserInfo()[1];
  const saveActiveLocation = useUserInfo()[5];
  const userActiveLocation = useUserInfo()[4];
  const setUserLocations = useUserInfo()[10];
  const checkLocation = useUserInfo()[15];
  const [loader, setloader] = useState(false);
  const [openmodellocation, setopenmodellocation] = useState(false);
  const [userActive, setuserActive] = useState();
  const [ActiveUserLocations, setActiveUserLocations] = useState([]);
  const [openmodel, setopenmodel] = useState(false);
  const [formInputs, setFormInputs] = useState({
    email: "",
    password: "",
    type: "email",
  });

  const handleFormChange = (e) => {
    setFormInputs({ ...formInputs, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    if (e?.type !== "google") e?.preventDefault();
    setloader(true);
    const payload = {
      ...(e?.type === "google" ? e : formInputs),
      role: "agency",
      ghlUser: false,
    };
    let response, error;
    try {
      response = await loginMutation.mutateAsync(payload);
    } catch (err) {
      error = err?.response?.data;
    }

    if (error?.message) {
      setError(error?.message);
      setloader(false);
      return;
    }

    if (response?.data) {
      const { token, ...user } = response.data;
      await localforage.setItem("token", token);
      await localforage.setItem("user", user);
      response?.brand && (await localforage.setItem("brand", response?.brand));
      response?.agency &&
        (await localforage.setItem("agency", response?.agency));

      setUserLocations(response?.activeLocations);
      if (response?.activeLocations?.length > 1) {
        setActiveUserLocations(response?.activeLocations);
        setuserActive(user);
        setopenmodellocation(true);
        return true;
      } else {
        if (response?.activeLocations?.length === 1) {
          await saveActiveLocation(response?.activeLocations[0]);
          updateUser(user);
          checkLocation(
            response?.activeLocations[0]?.id,
            user?.email,
            user?.userName,
            "stand_alone"
          );
          if (document.getElementById("appendsavelocation")?.innerHTML)
            setTimeout(() => {
              document.getElementById("appendsavelocation").innerHTML =
                response?.activeLocations[0]?.business_name;
            }, 1000);
        } else {
          if (
            response?.data?.verified === true &&
            response.activeLocations.length === 0
          ) {
            updateUser(user);
            return;
          } else {
            setError("Email is not verified! Please check your mail");
            setloader(false);
            return;
          }
        }
      }
    }
  };

  const handleSwitchAccount = async (location) => {
    if (location?.email === userActive?.email && !location?.customer_id) {
      try {
        await createCustomerMutation.mutateAsync({
          ...userActive,
          agency_id: location?.agency_id,
        });
      } catch (err) {
        // preserve prior behavior: createCustomer failures were silently ignored
      }
    }
    await saveActiveLocation(location);
    updateUser(userActive);
    setTimeout(() => {
      checkLocation(
        location?.id,
        userActive?.email,
        userActive?.userName,
        "stand_alone"
      );
      if (document.getElementById("appendsavelocation")?.innerHTML)
        document.getElementById("appendsavelocation").innerHTML =
          location?.business_name;
    }, 1000);
  };


  return (
    <div className="h-screen bg-background">
      <AuthTopBar />
      <div className="relative flex justify-center">
        {!window.location.hostname.includes('midahub') && <p className="text-muted-foreground absolute top-7 right-12">
          Do not have an account?{" "}
          <Link to={"/auth/sign-up"} className="text-foreground font-medium">
            Sign up
          </Link>
        </p>}
        <div className="text-center">
          <h1 className="font-semibold text-3xl mt-[58px]">
            Welcome back
          </h1>
          <p className="mt-3 text-center">
            Sign in to pick up where you left off with your Tasks, Agents and
            connected tools.
          </p>
          <GoogleSignIn
            buttonText={"Sign in with Google"}
            enabled
            onSuccess={handleFormSubmit}
            onUnavailable={setError}
          />
          <p className="relative border-b border-border my-6">
            <span className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 px-4 text-muted-foreground py-2 bg-background">
              OR
            </span>
          </p>
          <p className="mb-8">Enter your email and password below to sign in</p>
          <AuthForm
            formInputs={formInputs}
            onChange={handleFormChange}
            formType="Signin"
            handleSubmit={handleFormSubmit}
            error={error}
            loader={loader}
            handleForgetPassword={() => setopenmodel(true)}
          />
        </div>
      </div>
      {openmodellocation && (
        <>
          <LocationModal
            data={ActiveUserLocations}
            isModalOpen={openmodellocation}
            justCloseIt={() => setopenmodellocation(false)}
            handleSwitchAccount={handleSwitchAccount}
          ></LocationModal>
        </>
      )}
      <ForgetModel
        isModalOpen={openmodel}
        justCloseIt={() => setopenmodel(false)}
      ></ForgetModel>
    </div>
  );
};

export default SignInPage;
